import { Injectable } from '@angular/core';
import { ICustomFilter } from '@app/dashboard/maintenance/maintenance.interface';
import { StatsigService } from '@services/statsig.service';

export enum MAINTENANCE_FEATURE_FLAGS {
  MAINT_DVIR_CUSTOM_DEFECTS_LIST_ENABLED = 'maint-dvir-custom-defects-list-enabled',
  MAINT_INSPECTION_REPORT_DB_PARTITION_ENABLED = 'maintenance-inspection-report-db-partition-enabled',
  MAINT_DEFECT_LEVEL_RESOLUTION = 'maint-defect-level-resolution',
  MAINT_VEHICLE_SAFETY_PROMPT = 'maint-vehicle-safety-prompt',
  MAINT_VEHICLE_ASSET_AVAILABILITY = 'maintenance-vehicle-and-asset-availability-enabled',
  MAINT_SCHEDULE_TYPEAHEAD_FILTER_ENABLED = 'maintenance-schedules-list',
  MAINT_HISTORY_TYPEAHEAD_FILTER_ENABLED = 'maintenance-history-list',
  MAINT_HISTORY_DISPATCHER_TYPEAHEAD_FILTER_ENABLED = 'maintenance-history-list-dispatcher',
  MAINT_UPCOMING_TYPEAHEAD_FILTER_ENABLED = 'maintenance-upcoming-list',
  MAINT_HISTORY_DETAIL_REPORT_TYPEAHEAD_ENABLED = 'reports-maintenance-history-detail',
  MAINT_HISTORY_DETAIL_REPORT_DISPATCHER_TYPEAHEAD_ENABLED = 'reports-maintenance-history-detail-dispatcher',
  MAINT_BULK_TELEMATIC_ODOMETER = 'maint-bulk-telematic-odometer',
  INSPECTION_REPORTS_LIST_VEHICLES_AND_ASSETS_TYPEAHEAD_FILTER_ENABLED = 'inspection-reports-list-vehicles-and-assets',
  INSPECTION_REPORTS_LIST_DRIVERS_TYPEAHEAD_FILTER_ENABLED = 'inspection-reports-list-drivers',
  MAINT_SERVICE_NOTE_TYPEAHEAD_FILTER_ENABLED = 'maintenance-service-notes',
  MAINT_DISABLED_CUSTOM_SEARCH = 'fe-disable-custom-search',
  MAINT_FE_UPCOMING_UI_IMPROVEMENT = 'maint-fe-upcoming-ui-improvement',
  MAINT_FE_INSPECTION_OPEN_MAJOR_DEFECTS = 'maint-fe-inspection-open-major-defects',
  MAINT_CONDITIONAL_DVIR_ALERTS_ENABLED = 'maint-conditional-dvir-alerts-enabled',
}

const MAINT_FE_DVIR_CUSTOM_LIST_FILTER: string = 'maint-fe-dvir-custom-list-filter';

@Injectable({ providedIn: 'root' })
export class MaintenanceFeatureFlagService {
  constructor(private statsigService: StatsigService) {}

  public isCustomDefectsEnabled(): boolean {
    return this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_DVIR_CUSTOM_DEFECTS_LIST_ENABLED);
  }

  public isInspectionDBPartitionEnabled(): boolean {
    return this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_INSPECTION_REPORT_DB_PARTITION_ENABLED);
  }

  public dvirListCustomFilter(): ICustomFilter {
    return this.statsigService.evaluateDynamicConfig(MAINT_FE_DVIR_CUSTOM_LIST_FILTER).value as ICustomFilter;
  }

  public isDvirEnhancementV2Enabled(): boolean {
    return false;
  }

  public isDvirEnhancementV3Enabled(): boolean {
    return false;
  }

  public isDefectLevelResolutionEnabled(): boolean {
    return this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_DEFECT_LEVEL_RESOLUTION);
  }

  public isVehicleSafetyPromptEnabled(): boolean {
    return (
      this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_VEHICLE_SAFETY_PROMPT) &&
      this.isDefectLevelResolutionEnabled()
    );
  }

  public isVehicleAssetAvailabilityEnabled(): boolean {
    return this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_VEHICLE_ASSET_AVAILABILITY);
  }

  public isMaintBulkTelematicOdometerEnabled(): boolean {
    return this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_BULK_TELEMATIC_ODOMETER);
  }

  public isMaintCustomSearchDisabled(): boolean {
    return this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_DISABLED_CUSTOM_SEARCH);
  }

  public isUpcomingUIImprovementEnabled(): boolean {
    return this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_FE_UPCOMING_UI_IMPROVEMENT);
  }

  public isOpenMajorDefectsEnabled(): boolean {
    return this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_FE_INSPECTION_OPEN_MAJOR_DEFECTS);
  }

  public isConditionalDVIRAlertsEnabled(): boolean {
    return this.statsigService.evaluateGate(MAINTENANCE_FEATURE_FLAGS.MAINT_CONDITIONAL_DVIR_ALERTS_ENABLED);
  }
}
